// extracted by mini-css-extract-plugin
export default {"empty":"Dashboard_empty__HiXYY","container":"Dashboard_container__EuVMo"};